import type { LiteFilters, LiteTrade, Period } from "./types";

export const PERIOD_IDS: Period[] = ["today", "week", "month", "3m", "6m", "all"];

export function periodStart(period: Period, now = new Date()): Date | null {
  const d = new Date(now);
  d.setHours(0, 0, 0, 0);
  switch (period) {
    case "today": return d;
    case "week": d.setDate(d.getDate() - ((d.getDay() + 6) % 7)); return d;
    // Aligné sur presetToDateRange("last_30_days") de l'Advanced (aujourd'hui - 30 j).
    case "month": d.setDate(d.getDate() - 30); return d;
    case "3m": d.setMonth(d.getMonth() - 3); return d;
    case "6m": d.setMonth(d.getMonth() - 6); return d;
    case "all": return null;
  }
}

export function inPeriod(iso: string | Date, period: Period) {
  const start = periodStart(period);
  return !start || new Date(iso) >= start;
}

/** Fenêtre précédente de même durée, pour comparer (null pour « Tout »). */
export function previousWindow(period: Period, now = new Date()): { from: Date; to: Date } | null {
  const start = periodStart(period, now);
  if (!start) return null;
  const to = new Date(start);
  if (period === "today") { const from = new Date(start); from.setDate(from.getDate() - 1); return { from, to }; }
  if (period === "week") { const from = new Date(start); from.setDate(from.getDate() - 7); return { from, to }; }
  return { from: new Date(start.getTime() - (now.getTime() - start.getTime())), to };
}

/**
 * Filtres « qui » (compte, groupe de comptes, prop firm, stratégie), sans la période.
 * `scopeIds` : comptes retenus par compte / groupe / prop firm, ou null sans filtre de compte.
 */
export function matchScope(t: LiteTrade, f: LiteFilters, scopeIds: Set<string> | null) {
  if (scopeIds && (!t.accountId || !scopeIds.has(t.accountId))) return false;
  if (f.strategyId && !t.strategyIds.includes(f.strategyId)) return false;
  return true;
}
